import React from 'react';
import { 
  People as PeopleIcon,
  ReceiptLong as ReceiptLongIcon,
  Settings as SettingsIcon,
  PostAdd as PostAddIcon,
  Chat as ChatIcon,
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  Remove as RemoveIcon,
  Category as CategoryIcon
} from '@mui/icons-material';

// Support ticket categories
export const TICKET_CATEGORIES = [
  { id: 'account', label: 'Account Issues', icon: <PeopleIcon fontSize="small" />, color: '#4A90E2' },
  { id: 'billing', label: 'Billing Support', icon: <ReceiptLongIcon fontSize="small" />, color: '#50C878' },
  { id: 'technical', label: 'Technical Help', icon: <SettingsIcon fontSize="small" />, color: '#FF6B6B' },
  { id: 'feature', label: 'Feature Request', icon: <PostAddIcon fontSize="small" />, color: '#FFD700' },
  { id: 'general', label: 'General Inquiry', icon: <ChatIcon fontSize="small" />, color: '#9370DB' }
];

// Ticket statuses
export const TICKET_STATUSES = {
  open: { label: 'Open', color: '#4C85F0' },
  pending: { label: 'Pending', color: '#FF9800' },
  urgent: { label: 'Urgent', color: '#F44336' },
  closed: { label: 'Closed', color: '#66BB6A' }
};

// Ticket priorities
export const TICKET_PRIORITIES = {
  low: { label: 'Low', color: '#66BB6A', icon: ArrowDownwardIcon },
  medium: { label: 'Medium', color: '#FF9800', icon: RemoveIcon },
  high: { label: 'High', color: '#F44336', icon: ArrowUpwardIcon }
};

// Resource links
export const RESOURCE_LINKS = [
  { id: 'kb', label: 'Knowledge Base', url: '/knowledge-base' },
  { id: 'faq', label: 'FAQ', url: '/faq' },
  { id: 'templates', label: 'Response Templates', url: '/templates' },
  { id: 'wiki', label: 'Internal Wiki', url: '/wiki' },
  { id: 'scripts', label: 'Support Scripts', url: '/scripts' },
  { id: 'training', label: 'Training Videos', url: '/training' },
  { id: 'betfi', label: 'BetFI Presale', url: 'https://dev-sales.betfi365.com/', highlight: true }
];
